import { FeatureToggleItem, FeatureToggleName } from '@ac/library-api';

const READ_KEY_PERMISSION = '5d8819e9-d0da-41ab-86bd-5be797539b24';
export const hasPermissionToReadKey = (permissionIds: string[]): boolean =>
  permissionIds.includes(READ_KEY_PERMISSION);

export const isReadKeyFeatureOn = (toggles: FeatureToggleItem[]): boolean =>
  toggles.find((toggle) => toggle.featureName === FeatureToggleName.ReadKey)
    ?.enabled || false;
